/**
 * In-memory CSRF token store (spec §11.2, option 2). The token is delivered by
 * `GET /api/auth/session` and sent as `X-CSRF-Token` on mutations. It is NEVER
 * persisted to localStorage/sessionStorage and is cleared on logout.
 */
let csrfToken: string | null = null;

export function setCsrfToken(token: string | null): void {
  csrfToken = token;
}

export function getCsrfToken(): string | null {
  return csrfToken;
}

export function clearCsrfToken(): void {
  csrfToken = null;
}
